import React from "react";
import styled from "styled-components";
import { GlossyThemeProvider } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import UiKitIcon from "@ui-kit/icon";
import Loading from "@ui-kit/loader/dots";
import PostComponent from "@radarly/components/posts/post";
import { useContextualFocuses } from "@radarly/core/context/use-cases";
import { tr } from "@radarly/i18n";
import { Post } from "@radarly/models/posts";
import { Project } from "@radarly/models/project";

export interface SharedWidgetsPinnedPostProps {
  project: Project;
  post: Post;
  setIsNarrow?: (isNarrow: boolean) => void;
  loading: boolean;
  isError: boolean;
  locale: Locale;
  timezone: Timezone;
  readOnly: boolean;
}
const Root = styled.div`
  height: 100%;
`;

const Info = styled.div`
  margin-top: 20px;
`;

const MsgContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  text-align: center;
`;

export default function SharedWidgetsPinnedPost({
  project,
  post,
  setIsNarrow,
  loading,
  isError,
  locale,
  timezone,
  readOnly = false,
}: SharedWidgetsPinnedPostProps) {
  const contextualFocuses = useContextualFocuses();

  return (
    <Root>
      {loading ? (
        <MsgContainer>
          <Loading />
        </MsgContainer>
      ) : isError ? (
        <MsgContainer>
          <UiKitIcon glyph="ghost" size={104} />
          <Info>{tr(locale, "PINNED_POST_CARD_PLACEHOLDER_ERROR")}</Info>
        </MsgContainer>
      ) : post ? (
        <GlossyThemeProvider name="surface">
          <PostComponent
            post={post}
            project={project}
            locale={locale}
            timezone={timezone}
            queries={contextualFocuses}
            setIsNarrow={setIsNarrow}
            isPinnedPost
            readOnly={readOnly}
          />
        </GlossyThemeProvider>
      ) : (
        <MsgContainer>
          {tr(locale, "PINNED_POST_CARD_PLACEHOLDER")}
        </MsgContainer>
      )}
    </Root>
  );
}
